import { ContainerJourneyDto, ReportsApi } from '../app/api'
import { authStore } from '@tom-ui/utils'
import { createApiClient } from '../app/http-client'

class ReportsService {
  httpClient = createApiClient(ReportsApi)

  getContainerJourneys = async (
    from: Date,
    to: Date,
    vesselVisitId?: number,
  ): Promise<ContainerJourneyDto[]> => {
    const { data } = await this.httpClient.integrationApiInternalReportsGetContainerJourneysGet(
      authStore.tenantId,
      from.toISOString(),
      to.toISOString(),
      vesselVisitId,
    )

    return data
  }
}

const reportsService = new ReportsService()

export default reportsService
